/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs */

const en_admin_resources_resource_allocations_empty_manage_resources = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Resources`)
};

const de_admin_resources_resource_allocations_empty_manage_resources = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen verwalten`)
};

const es_admin_resources_resource_allocations_empty_manage_resources = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar recursos`)
};

const fr_admin_resources_resource_allocations_empty_manage_resources = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les ressources`)
};

const nl_admin_resources_resource_allocations_empty_manage_resources = /** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorzieningen beheren`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_empty_manage_resources = en_admin_resources_resource_allocations_empty_manage_resources;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_empty_manage_resources = en_admin_resources_resource_allocations_empty_manage_resources;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_empty_manage_resources = en_admin_resources_resource_allocations_empty_manage_resources;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_empty_manage_resources = en_admin_resources_resource_allocations_empty_manage_resources;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_empty_manage_resources = en_admin_resources_resource_allocations_empty_manage_resources;

/**
* | output |
* | --- |
* | "Manage Resources" |
*
* @param {Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_empty_manage_resources = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Empty_Manage_ResourcesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_empty_manage_resources(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_empty_manage_resources(inputs)
	return ro_admin_resources_resource_allocations_empty_manage_resources(inputs)
});
export { admin_resources_resource_allocations_empty_manage_resources as "admin.resources.resource_allocations.empty_manage_resources" }